import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Plugins register once, in the browser only. Every animation is created inside an effect.
if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
}

export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export { gsap, ScrollTrigger }
